import React from "react";
import { Reveal, SectionOverline } from "./Shared";
import { Brain, Dumbbell, Pill, Users } from "lucide-react";

const ITEMS = [
  {
    icon: Brain,
    title: "Talk therapy",
    body:
      "Insight is not intervention. Understanding a pattern rarely changes the physiology that produces it.",
    testId: "traditional-talk-therapy",
  },
  {
    icon: Dumbbell,
    title: "Fitness programs",
    body:
      "Training for aesthetics or performance often leaves the underlying stress state — and the behavior it produces — largely untouched.",
    testId: "traditional-fitness",
  },
  {
    icon: Pill,
    title: "Medication alone",
    body:
      "Pharmacology can modulate symptoms, but on its own it rarely retrains the nervous system producing them.",
    testId: "traditional-medication",
  },
  {
    icon: Users,
    title: "Willpower & accountability",
    body:
      "Discipline applied to a dysregulated state is a fragile strategy. Over time, the state tends to prevail.",
    testId: "traditional-willpower",
  },
];

const WhyTraditionalFails = () => {
  return (
    <section
      id="why-traditional-fails"
      data-testid="why-traditional-fails-section"
      className="relative py-32 sm:py-40 border-t forr-canvas"
      style={{ borderColor: "var(--forr-line-soft)" }}
    >
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10 lg:px-16">
        <div className="grid grid-cols-12 gap-8">
          <div className="col-span-12 lg:col-span-5">
            <Reveal>
              <SectionOverline
                number="02"
                label="Why Traditional Approaches Fail"
                testId="why-traditional-overline"
              />
            </Reveal>
            <Reveal delay={0.05}>
              <h2
                data-testid="why-traditional-heading"
                className="mt-8 font-display forr-text-ink text-4xl sm:text-5xl md:text-6xl font-medium tracking-[-0.02em] leading-[1.05]"
              >
                Most methods target the surface.
              </h2>
            </Reveal>
            <Reveal delay={0.15}>
              <p className="mt-8 max-w-md text-lg font-light forr-text-soft leading-relaxed">
                They address thoughts, symptoms, or motivation — but rarely
                retrain the physiological state that produces behavior in the
                first place.
              </p>
            </Reveal>
          </div>

          <div className="col-span-12 lg:col-span-7 lg:pl-8">
            <div className="grid sm:grid-cols-2 gap-6">
              {ITEMS.map((it, i) => (
                <Reveal delay={i * 0.08} key={it.title}>
                  <div
                    data-testid={`card-${it.testId}`}
                    className="forr-card rounded-[24px] p-8 lg:p-10 h-full"
                  >
                    <div
                      className="w-11 h-11 rounded-2xl flex items-center justify-center mb-8"
                      style={{
                        backgroundColor: "var(--forr-teal-soft)",
                        color: "var(--forr-teal-deep)",
                      }}
                    >
                      <it.icon size={20} strokeWidth={1.5} />
                    </div>
                    <h3 className="font-display forr-text-ink text-xl font-medium tracking-tight mb-3">
                      {it.title}
                    </h3>
                    <p className="text-sm font-light forr-text-soft leading-relaxed">
                      {it.body}
                    </p>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyTraditionalFails;
